module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("שם השחקן ")]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "fontSize": "50px"
    }
  }, [_vm._v(_vm._s(_vm.playerName) + "  ")]), _vm._v(" "), (!_vm.mode) ? _c('div', {
    staticClass: "turnDisplay"
  }, [(_vm.turn === 'playerOne') ? _c('h2', [_vm._v("Player One")]) : _vm._e(), _vm._v(" "), (_vm.turn === 'playerTwo') ? _c('h2', [_vm._v("Player Two")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('app-questions'), _vm._v(" "), _c('app-score-dots'), _vm._v(" "), _c('app-star-power')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15c8726e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GameBoard.vue
// module id = 46
// module chunks = 0